module.exports = __webpack_public_path__ + "../assets/dekstop-1.jpg";